import React from 'react'

const Loader = () => <div className="loader"><span className="sr_only">Loading...</span></div>
export default Loader
